module.exports = __webpack_public_path__ + "img/ATUALIDADES.608c16a4.png";